<template>
  <Loader style="z-index: 1000;" v-if="loader" />

  <div class="flex flex-column justify-content-center align-items-center h-full gap-3">
    <h2>PREVISIONALE</h2>

    <div class="flex flex-column justify-content-center align-items-center w-full mt-4">
      <h5 class="mb-2">Generale</h5>

      <DataTable :value="datiPrevisione.general" tableStyle="min-width: 80rem" class="border-round shadow-5 p-2"
        :rowClass="rowClass">
        <Column field="pdp" header="PDP" headerStyle="min-width: 20rem;"></Column>
        <Column field="precedente" header="Mese precedente"></Column>
        <Column field="attuale" header="Mese attuale (Offset)">
          <template #body="slotProps">
            <span style="font-weight: bold;">
              {{ slotProps.data.attuale }}
            </span>
          </template>
        </Column>
        <Column field="prossimo" header="Mese prossimo (Offset)"></Column>
      </DataTable>
    </div>

    <div style="display: flex; gap: 10px; margin: 2%;">
      <Button label="POD" icon="pi pi-lightbulb" class="p-button-info" @click="filtra('pod')" />
      <Button label="PDR" icon="pi pi-cloud" class="p-button-info" @click="filtra('pdr')" />
    </div>

    <div v-if="pdpFiltro === 'pod'">
      <div class="flex flex-column justify-content-center align-items-center w-full mt-4">
        <h5 class="mb-2">Fornitori POD</h5>

        <DataTable :value="datiPrevisione.podUdd" tableStyle="min-width: 80rem" class="border-round shadow-5 p-2"
          :paginator="true" :rows="10" style="min-height: 400px;">
          <Column field="udd" header="UDD" headerStyle="min-width: 20rem;" sortable ></Column>
          <Column field="last" header="Mese precedente" sortable ></Column>
          <Column field="now" header="Mese attuale" sortable>
            <template #body="slotProps">
              <span style="font-weight: bold;">
                {{ slotProps.data.now }}
              </span>
            </template>
          </Column>
          <Column field="after" header="Prossimo mese" sortable ></Column>
          
          <Column field="diff" header="Offset" sortable>
            <template #body="slotProps">
              <span :style="{
                color: slotProps.data.diff > 0 ? 'green' :
                      slotProps.data.diff < 0 ? 'red' : 'gray'
              }">
                {{ slotProps.data.diff }} ({{ slotProps.data.diff_percent }}%)
              </span>
            </template>
          </Column>

          <Column field="consumo" header="Consumo Annuo" sortable ></Column>
          <Column field="pma" header="PMA" sortable ></Column>
        </DataTable>
      </div>

      <div class="flex flex-column justify-content-center align-items-center w-full mt-4">
        <h5 class="mb-2">Agenti POD</h5>

        <DataTable :value="datiPrevisione.podAgenti" tableStyle="min-width: 80rem" class="border-round shadow-5 p-2"
          :paginator="true" :rows="10" style="min-height: 400px;">
          <Column field="agent" header="AGENTI" headerStyle="min-width: 20rem;" sortable ></Column>
          <Column field="last" header="Mese precedente" sortable ></Column>
          <Column field="now" header="Mese attuale" sortable>
            <template #body="slotProps">
              <span style="font-weight: bold;">
                {{ slotProps.data.now }}
              </span>
            </template>
          </Column>
          <Column field="after" header="Prossimo mese" sortable ></Column>
          
          <Column field="diff" header="Offset" sortable>
            <template #body="slotProps">
              <span :style="{
                color: slotProps.data.diff > 0 ? 'green' :
                      slotProps.data.diff < 0 ? 'red' : 'gray'
              }">
                {{ slotProps.data.diff }} ({{ slotProps.data.diff_percent }}%)
              </span>
            </template>
          </Column>

          <Column field="consumo" header="Consumo Annuo" sortable ></Column>
          <Column field="pma" header="PMA" sortable ></Column>
        </DataTable>
      </div>

      <div class="flex flex-column justify-content-center align-items-center w-full mt-4">
        <h5 class="mb-2">Dettagli POD</h5>

        <div class="flex justify-content-end gap-2 w-full md:w-30rem mb-2" style="margin-left: auto; gap: 0.5rem;">
          <InputText
            v-model="filtroPod"
            placeholder="Cerca POD..."
            class="w-full"
            @update:modelValue="onFiltroPodUpdate"
          />
          <Button 
            label="CSV" 
            icon="pi pi-file-export" 
            class="p-button-sm p-button-secondary ml-4"
            @click="exportDetails()"
          />
        </div>

        <DataTable 
          :value="datiPrevisione.pod_dettagli" 
          tableStyle="min-width: 80rem" 
          class="border-round shadow-5 p-2"
          :paginator="true"
          :rows="datiPrevisione.pod_dettagli_per_page"
          :totalRecords="datiPrevisione.pod_dettagli_tot_records"
          :lazy="true"
          :sortField="sortField"
          :sortOrder="sortOrder"
          @sort="getPodDetailsPrevisionale"
          @page="getPodDetailsPrevisionale"
          style="min-height: 400px;"
        >
          <Column field="code" header="POD" headerStyle="min-width: 15rem;" sortable />
          <Column field="area_rif" header="Area Riferimento" sortable />
          <Column field="tariffa_distribuzione" header="Tariffa Distribuzione" sortable />
          <Column field="tensione" header="Tensione" sortable />
          <Column field="potcontrimp" header="Potenza Impegnata" sortable />
          <Column field="potdisp" header="Potenza Disponibile" sortable />
          <Column field="consumo" header="Consumo Annuo" sortable />
          <Column field="pma" header="PMA" sortable />
        </DataTable>
      </div>
    </div>


    <div v-if="pdpFiltro === 'pdr'">

      <div class="flex flex-column justify-content-center align-items-center w-full mt-4">
        <h5 class="mb-2">Fornitori PDR</h5>

        <DataTable :value="datiPrevisione.pdrUdd" tableStyle="min-width: 80rem" class="border-round shadow-5 p-2"
          :paginator="true" :rows="10" style="min-height: 400px;">
          <Column field="udd" header="UDD" headerStyle="min-width: 20rem;" sortable></Column>
          <Column field="last" header="Mese precedente" sortable ></Column>
          <Column field="now" header="Mese attuale" sortable>
            <template #body="slotProps">
              <span style="font-weight: bold;">
                {{ slotProps.data.now }}
              </span>
            </template>
          </Column>
          <Column field="after" header="Prossimo mese" sortable></Column>

          <Column field="diff" header="Offset" sortable>
            <template #body="slotProps">
              <span :style="{
                color: slotProps.data.diff > 0 ? 'green' :
                      slotProps.data.diff < 0 ? 'red' : 'gray'
              }">
                {{ slotProps.data.diff }} ({{ slotProps.data.diff_percent }}%)
              </span>
            </template>
          </Column>

          <Column field="consumo" header="Consumo Annuo" sortable></Column>
        </DataTable>
      </div>

      <div class="flex flex-column justify-content-center align-items-center w-full mt-4">
        <h5 class="mb-2">Agenti PDR</h5>

        <DataTable :value="datiPrevisione.pdrAgenti" tableStyle="min-width: 80rem" class="border-round shadow-5 p-2"
          :paginator="true" :rows="10" style="min-height: 400px;">
          <Column field="agent" header="AGENTI" headerStyle="min-width: 20rem;" sortable></Column>
          <Column field="last" header="Mese precedente" sortable ></Column>
          <Column field="now" header="Mese attuale" sortable>
            <template #body="slotProps">
              <span style="font-weight: bold;">
                {{ slotProps.data.now }}
              </span>
            </template>
          </Column>
          <Column field="after" header="Prossimo mese" sortable></Column>

          <Column field="diff" header="Offset" sortable>
            <template #body="slotProps">
              <span :style="{
                color: slotProps.data.diff > 0 ? 'green' :
                      slotProps.data.diff < 0 ? 'red' : 'gray'
              }">
                {{ slotProps.data.diff }} ({{ slotProps.data.diff_percent }}%)
              </span>
            </template>
          </Column>

          <Column field="consumo" header="Consumo Annuo" sortable></Column>
        </DataTable>
      </div>

      <div class="flex flex-column justify-content-center align-items-center w-full mt-4">
        <h5 class="mb-2">Dettagli PDR</h5>

        <div class="flex justify-content-end gap-2 w-full md:w-30rem mb-2" style="margin-left: auto; gap: 0.5rem;">
          <InputText
            v-model="filtroPdr"
            placeholder="Cerca PDR..."
            class="w-full"
            @update:modelValue="onFiltroPdrUpdate"
          />
          <Button 
            label="CSV" 
            icon="pi pi-file-export" 
            class="p-button-sm p-button-secondary ml-4"
            @click="exportDetails()"
          />
        </div>

        <DataTable :value="datiPrevisione.pdr_dettagli" tableStyle="min-width: 80rem" class="border-round shadow-5 p-2"
          :paginator="true"
          :rows="datiPrevisione.pdr_dettagli_per_page"
          :totalRecords="datiPrevisione.pdr_dettagli_tot_records"
          :lazy="true"
          :sortField="sortField"
          :sortOrder="sortOrder"
          @sort="getPdrDetailsPrevisionale"
          @page="getPdrDetailsPrevisionale"
          style="min-height: 400px;">
          <Column field="code" header="PDR" headerStyle="min-width: 15rem;" sortable></Column>
          <Column field="remi" header="Remi" sortable></Column>
          <Column field="profilo" header="Profilo Prelievo" sortable></Column>
          <Column field="classe" header="Categoria Uso" sortable></Column>
          <Column field="consumo" header="Consumo Annuo" sortable></Column>
        </DataTable>
      </div>
    </div>

  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import { ref, onMounted, getCurrentInstance, reactive } from "vue";
import Service from "@/services/ask-pratiche/pratiche-service";
import { isEmpty } from "underscore";

export default {
  components: {
    Loader
  },
  setup() {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const loader = ref(false);
    const pdpFiltro = ref('');
    const filtroPod = ref('');
    const filtroPdr = ref('');

    const datiPrevisione = reactive({

      general: [],

      podUdd: [],
      podAgenti: [],
      pod_dettagli: [],
      pod_dettagli_tot_records: 0,
      pod_dettagli_per_page: 50,
      pod_dettagli_current_page: 1,

      pdrUdd: [],
      pdrAgenti: [],
      pdr_dettagli: [],
      pdr_dettagli_tot_records: 0,
      pdr_dettagli_per_page: 50,
      pdr_dettagli_current_page: 1,

    });

    const rowClass = (data) => {
      return Object.values(data).includes("TOT") ? 'highlight-row' : '';
    };

    const caricaPrevisioni = async () => {
      loader.value = true;

      let datiPod = null;
      let datiPdr = null;

      await Promise.all([
        service.getPrevisionalePod().then(res => {
          datiPod = res;
          datiPrevisione.general.push({
            'pdp': 'POD',
            'precedente': `${res.podMeseScorso}`,
            'attuale': `${res.podAttivi} (${res.percentualeGuadagnoAttuale}%)`,
            'prossimo': `${res.podPrevisione} (${res.percentualeGuadagnoPrevisione}%)`
          });
        }),

        service.getPrevisionalePdr().then(res => {
          datiPdr = res;
          datiPrevisione.general.push({
            'pdp': 'PDR',
            'precedente': `${res.pdrMeseScorso}`,
            'attuale': `${res.pdrAttivi} (${res.percentualeGuadagnoAttuale}%)`,
            'prossimo': `${res.pdrPrevisione} (${res.percentualeGuadagnoPrevisione}%)`
          });
        })
      ]);

      const precedenteTot = datiPod.podMeseScorso + datiPdr.pdrMeseScorso;
      const attualeTot = datiPod.podAttivi + datiPdr.pdrAttivi;
      const prossimoTot = datiPod.podPrevisione + datiPdr.pdrPrevisione;

      const crescitaAttuale = ((attualeTot - precedenteTot) / precedenteTot) * 100;
      const crescitaPrevisione = ((prossimoTot - precedenteTot) / precedenteTot) * 100;

      datiPrevisione.general.push({
        'pdp': 'TOT',
        'precedente': precedenteTot,
        'attuale': `${attualeTot} (${crescitaAttuale.toFixed(2)}%)`,
        'prossimo': `${prossimoTot} (${crescitaPrevisione.toFixed(2)}%)`
      });

      loader.value = false;
    };

    // POD

    const caricaUddAgentiPod = async () => {
      loader.value = true;

      try {
        const res = await service.getPrevisionaleUddAgentiPod();

        // Fornitori
        const fornitori = Object.keys(res.uddAttivi);
        const fornitoriPrevisione = Object.keys(res.uddPrevisione);
        const tuttiFornitori = [...new Set([...fornitori, ...fornitoriPrevisione])].sort();

        tuttiFornitori.forEach((fornitore) => {
          const fornitoreScorsoMese = res.uddScorsoMese[fornitore] || {};
          const fornitoreAttivo = res.uddAttivi[fornitore] || {};
          const fornitorePrevisione = res.uddPrevisione[fornitore] || {};

          let last = fornitoreScorsoMese.count || 0;
          let now = fornitoreAttivo.count || 0;
          let after = fornitorePrevisione.count || 0;

          let diff = after - now;
          let diffPercent = now !== 0 ? ((diff / now) * 100).toFixed(2) : '0.00';

          datiPrevisione.podUdd.push({
            'udd': fornitore,
            'last': last,
            'now': now,
            'after': after,
            'diff': diff,
            'diff_percent': diffPercent,
            'consumo': fornitoreAttivo.consumo_annuo?.toFixed(2) || 0,
            'pma': fornitoreAttivo.pma?.toFixed(2) || 0,
          });
        });

        // Agenti
        const agenti = Object.keys(res.agentiAttivi);
        const agentiPrevisione = Object.keys(res.agentiPrevisione);
        const tuttiAgenti = [...new Set([...agenti, ...agentiPrevisione])].sort();

        tuttiAgenti.forEach((agente) => {
          const agenteScorsoMese = res.agentiScorsoMese[agente] || {};
          const agenteAttivo = res.agentiAttivi[agente] || {};
          const agentePrevisione = res.agentiPrevisione[agente] || {};

          let last = agenteScorsoMese.count || 0;
          let now = agenteAttivo.count || 0;
          let after = agentePrevisione.count || 0;

          let diff = after - now;
          let diffPercent = now !== 0 ? ((diff / now) * 100).toFixed(2) : '0.00';

          datiPrevisione.podAgenti.push({
            'agent': agente,
            'last': last,
            'now': now,
            'after': after,
            'diff': diff,
            'diff_percent': diffPercent,
            'consumo': agenteAttivo.consumo_annuo?.toFixed(2) || 0,
            'pma': agenteAttivo.pma?.toFixed(2) || 0,
          });
        });

      } catch (error) {
        console.error('Errore nel caricamento:', error);
      } finally {
        loader.value = false;
      }
    };

    const getPodDetailsPrevisionale = (event = {}) => {

      const newPage = event.page !== undefined ? event.page + 1 : 1;
      const sortField = event.sortField || datiPrevisione.sortField;
      const sortOrder = event.sortOrder || datiPrevisione.sortOrder;

      datiPrevisione.sortField = sortField;
      datiPrevisione.sortOrder = sortOrder;

      loader.value = true;

      service.getPrevisionaleDettagliPod(newPage, filtroPod.value, sortField, sortOrder)
        .then(res => {
          datiPrevisione.pod_dettagli = res.data;
          datiPrevisione.pod_dettagli_current_page = res.current_page;
          datiPrevisione.pod_dettagli_per_page = res.per_page;
          datiPrevisione.pod_dettagli_tot_records = res.total;
        })
        .finally(() => loader.value = false);
    };

    const onFiltroPodUpdate = (val) => {
      filtroPod.value = val;
      if (filtroPod.value.length > 10 || filtroPod.value.length == 0) {
        getPodDetailsPrevisionale();
      }
    };

    const onFiltroPdrUpdate = (val) => {
      filtroPdr.value = val;
      if (filtroPdr.value.length > 10 || filtroPdr.value.length == 0) {
        getPdrDetailsPrevisionale();
      }
    };

    // PDR

    const caricaUddAgentiPdr = async () => {
      loader.value = true;

      try {
        const res = await service.getPrevisionaleUddAgentiPdr();

        // Fornitori
        const fornitori = Object.keys(res.uddAttivi);
        const fornitoriPrevisione = Object.keys(res.uddPrevisione);
        const tuttiFornitori = [...new Set([...fornitori, ...fornitoriPrevisione])].sort();

        tuttiFornitori.forEach((fornitore) => {
          const fornitoreScorsoMese = res.uddScorsoMese[fornitore] || {};
          const fornitoreAttivo = res.uddAttivi[fornitore] || {};
          const fornitorePrevisione = res.uddPrevisione[fornitore] || {};

          let last = fornitoreScorsoMese.count || 0;
          let now = fornitoreAttivo.count || 0;
          let after = fornitorePrevisione.count || 0;

          let diff = after - now;
          let diffPercent = now !== 0 ? ((diff / now) * 100).toFixed(2) : '0.00';

          datiPrevisione.pdrUdd.push({
            'udd': fornitore,
            'last': last,
            'now': now,
            'after': after,
            'diff': diff,
            'diff_percent': diffPercent,
            'consumo': fornitoreAttivo.consumo_annuo?.toFixed(2) || 0,
          });
        });

        // Agenti
        const agenti = Object.keys(res.agentiAttivi);
        const agentiPrevisione = Object.keys(res.agentiPrevisione);
        const tuttiAgenti = [...new Set([...agenti, ...agentiPrevisione])].sort();

        tuttiAgenti.forEach((agente) => {
          const agenteScorsoMese = res.agentiScorsoMese[agente] || {};
          const agenteAttivo = res.agentiAttivi[agente] || {};
          const agentePrevisione = res.agentiPrevisione[agente] || {};

          let last = agenteScorsoMese.count || 0;
          let now = agenteAttivo.count || 0;
          let after = agentePrevisione.count || 0;

          let diff = after - now;
          let diffPercent = now !== 0 ? ((diff / now) * 100).toFixed(2) : '0.00';

          datiPrevisione.pdrAgenti.push({
            'agent': agente,
            'last': last,
            'now': now,
            'after': after,
            'diff': diff,
            'diff_percent': diffPercent,
            'consumo': agenteAttivo.consumo_annuo?.toFixed(2) || 0,
          });
        });

      } catch (error) {
        console.error('Errore nel caricamento:', error);
      } finally {
        loader.value = false;
      }
    };

    const getPdrDetailsPrevisionale = (event = {}) => {
      const newPage = event.page !== undefined ? event.page + 1 : 1;
      const sortField = event.sortField || datiPrevisione.sortFieldPdr;
      const sortOrder = event.sortOrder || datiPrevisione.sortOrderPdr;

      datiPrevisione.sortFieldPdr = sortField;
      datiPrevisione.sortOrderPdr = sortOrder;

      loader.value = true;

      service.getPrevisionaleDettagliPdr(newPage, filtroPdr.value, sortField, sortOrder)
        .then(res => {
          datiPrevisione.pdr_dettagli = res.data;
          datiPrevisione.pdr_dettagli_current_page = res.current_page;
          datiPrevisione.pdr_dettagli_per_page = res.per_page;
          datiPrevisione.pdr_dettagli_tot_records = res.total;
          loader.value = false
        })
        .catch(
          () => loader.value = false
        );
    }

    const filtra = (tipoPdp) => {
      if (tipoPdp === 'pod') {
        pdpFiltro.value = 'pod';
        if (isEmpty(datiPrevisione.podUdd)) {
          caricaUddAgentiPod();
          getPodDetailsPrevisionale({ page: 0 });
        }
      } else if (tipoPdp === 'pdr') {
        pdpFiltro.value = 'pdr';
        if (isEmpty(datiPrevisione.pdrUdd)) {
          caricaUddAgentiPdr();
          getPdrDetailsPrevisionale({ page: 0 });
        }
      }
    }

    const exportDetails = () => {
      if (pdpFiltro.value === 'pod') {
        service.exportPodDettagliPrevisionalePod();
      } else if (pdpFiltro.value === 'pdr') {
        service.exportPodDettagliPrevisionalePdr();
      }
    }

    onMounted(() => {
      caricaPrevisioni();
    });

    return {
      loader,
      pdpFiltro,
      datiPrevisione,
      rowClass,
      filtra,
      exportDetails,
      getPodDetailsPrevisionale,
      getPdrDetailsPrevisionale,
      onFiltroPodUpdate,
      onFiltroPdrUpdate
    };
  }
}
</script>

<style>
  .highlight-row {
    background-color: #fff8dd !important;
    font-weight: bold !important;
    color: #000 !important;
    border: 2px solid black;
  }
</style>